import { motion } from 'framer-motion'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React, { useMemo } from 'react'
import { Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'

import ImageByWidthDevice from '@/components/ImageByWidthDevice'
import { introLeftVariants } from '@/config/const'
import { getHomeBanner } from '@/services/home'
import { HomeBannerListRequest } from '@/types/home'
import { useAppSelector } from '@/utils/hooks'

import Scroll from '~/assets/images/scroll.gif'

const Banner: React.FC = () => {
  const router = useRouter()
  const { t } = useTranslation()

  const requestList: HomeBannerListRequest = useMemo(() => {
    return {
      params: { skip: 0, limit: 1000 },
      headers: { 'Accept-Language': String(router.locale) },
    }
  }, [])

  const { data: banner } = useAppSelector(getHomeBanner.select(requestList))
  if (banner?.data.items.length) {
    return (
      <div className='relative flex h-mobile-screen w-full items-center justify-center lg:h-screen'>
        <Swiper
          lazy
          modules={[Autoplay]}
          className='banner-swiper'
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          {banner?.data.items.map((banner) => (
            <SwiperSlide key={banner.xid}>
              <div className='relative flex h-full w-full items-center justify-center'>
                <div className='absolute inset-0'>
                  <ImageByWidthDevice
                    images={banner.imageFiles}
                    className='absolute z-0 h-full w-full object-cover object-center'
                    alt={banner.imageFiles.desktop.filename ?? ''}
                  />

                  <div className='absolute inset-0 z-10 bg-black/20' />
                </div>

                <motion.header
                  className='container z-20 flex w-full items-center justify-center overflow-hidden lg:justify-start'
                  initial='hide'
                  whileInView='show'
                  viewport={{ once: true }}
                  variants={introLeftVariants}
                >
                  <div
                    className='description w-[621px] break-words text-center text-[28px] font-bold uppercase leading-normal text-white lg:text-start lg:text-[55px]'
                    dangerouslySetInnerHTML={{ __html: banner.description }}
                  />
                </motion.header>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className='absolute bottom-0 z-20 flex items-center justify-center gap-2 py-5 text-white'>
          <span className='text-sm lg:text-base'>{t('home:banner.scrollText1')}</span>
          <img
            src={Scroll.src}
            alt='Scroll'
            className='h-6 lg:h-8'
          />
          <span className='text-sm lg:text-base'>{t('home:banner.scrollText2')}</span>
        </div>
      </div>
    )
  } else {
    return null
  }
}
export default Banner
